const preparedName = name => {
  const text = name.split(' ').map(part => part[0].toUpperCase() + part.slice(1))

  return text.join('')
}

export default {
  setBhUserRoleIds (state, payload) {
    state.dictionaryBhUsersRoleIds = payload.reduce((acc, item) => {
      acc[item.id] = item.dictionaryItem
      acc[preparedName(item.dictionaryItem)] = item.id
      return acc
    }, {})
    Object.freeze(state.dictionaryBhUsersRoleIds)
  },
  setPracticeUserRole (state, payload) {
    state.dictionaryPracticeUserRole = payload.reduce((acc, item) => {
      acc[item.id] = item.dictionaryItem
      acc[preparedName(item.dictionaryItem)] = item.id
      return acc
    }, {})
    Object.freeze(state.dictionaryBhUsersRoleIds)
  },
  setFileTypes (state, payload) {
    state.dictionaryFileType = payload.reduce((acc, item) => {
      acc[item.id] = item.dictionaryItem
      acc[preparedName(item.dictionaryItem)] = item.id
      return acc
    }, {})
    Object.freeze(state.dictionaryFileType)
  },
  setDictionariesLoaded (state) {
    state.dictionariesLoaded = true
  },
  setSupportedFileTypes (state, payload) {
    state.dictionarySupportedFileTypes = payload.reduce((acc, item) => {
      if (acc[item.fileTypeId]) acc[item.fileTypeId].push(item.contentType)
      else acc[item.fileTypeId] = [item.contentType]
      return acc
    }, {})
    Object.freeze(state.dictionarySupportedFileTypes)
  },
  setFeatureFlagState (state, payload) {
    state.dictionaryFeatureFlagState = payload.reduce((acc, item) => {
      acc[item.id] = item.dictionaryItem
      acc[preparedName(item.dictionaryItem)] = item.id
      return acc
    }, {})
    Object.freeze(state.dictionaryFeatureFlagState)
  },
  setAuditableOperations (state, payload) {
    state.dictionaryAuditableOperations = payload.reduce((acc, item) => {
      acc[item.dictionaryItem] = item.dictionaryItem
      return acc
    }, {})
    Object.freeze(state.dictionaryAuditableOperations)
  },
  setAuditableTypes (state, payload) {
    state.dictionaryAuditableTypes = payload.reduce((acc, item) => {
      acc[item.dictionaryItem] = item.dictionaryItem
      return acc
    }, {})
    Object.freeze(state.dictionaryAuditableTypes)
  }
}
